import { useLocale } from 'next-intl';

import useNearestLocation from '@/hooks/useNearestLocation';
import { createMeetingLeadDto } from '@/lib/leads/leads';
import { SimpleLocationDto } from '@/lib/locations/dto';

import MeetingEventSpaceInquiryForm from '../../../meeting-event-space-inquiry/_components/MeetingEventSpaceInquiryForm';
import { DateFlexibility } from '../../../meeting-event-space-inquiry/_components/types';
import { useLeadCreation } from '../useLeadCreation';

type MeetingFormProps = {
  allLocations: SimpleLocationDto[];
};

export function MeetingForm({ allLocations }: MeetingFormProps) {
  const { isLoading, handleFormSubmitted } = useLeadCreation();
  const locale = useLocale();
  const { nearestLocation: location } = useNearestLocation({ locale });

  return (
    <MeetingEventSpaceInquiryForm
      defaultValues={{
        location,
        dateFlexibility: DateFlexibility.Exact,
      }}
      allLocations={allLocations}
      onSubmit={(form) => handleFormSubmitted(createMeetingLeadDto(form))}
      isLoading={isLoading}
    />
  );
}
